import * as actions from "../action.constants";

const requestInventoryReports = (pageUrl) => ({
  type: actions.REQUEST_INVENTORY_REPORTS,
  pageUrl,
});

const saveInventoryReports = (data) => ({
  type: actions.STORE_INVENTORY_REPORTS,
  payload: data,
});

export {requestInventoryReports, saveInventoryReports};
